var _defs, _clipPath, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIco11(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24.961,
    height: 22.383,
    viewBox: "0 0 24.961 22.383",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 0h24.96v22.383H0z"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    overflow: "visible"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    d: "M17.988 0c-.547 0-1.084.06-1.61.176S15.35.47 14.882.703s-.908.518-1.318.85-.77.713-1.084 1.143c-.312-.43-.673-.81-1.083-1.143s-.85-.615-1.318-.85S9.11.293 8.584.176 7.52 0 6.973 0c-.977 0-1.885.186-2.725.557s-1.572.87-2.197 1.494C1.388 2.677.88 3.41.528 4.25S0 5.996 0 6.973c0 .43.04.87.117 1.318s.195.87.352 1.26c.194.43.41.83.644 1.202s.508.713.82 1.025L12.48 22.383l10.37-10.43c.353-.313.655-.664.91-1.055s.478-.78.673-1.172c.156-.43.283-.88.38-1.348s.147-.938.147-1.406c0-.977-.176-1.885-.527-2.725s-.86-1.572-1.523-2.197c-.625-.625-1.357-1.123-2.197-1.494S18.965 0 17.988 0zm0 .996c.82 0 1.592.156 2.314.47s1.357.74 1.904 1.288.977 1.182 1.29 1.904.468 1.494.468 2.314c0 .43-.04.84-.117 1.23s-.195.78-.352 1.172c-.156.352-.352.684-.586.996s-.49.605-.763.88l-9.668 9.726-9.845-9.902c-.234-.234-.46-.508-.674-.82s-.4-.645-.556-.996c-.115-.352-.213-.723-.29-1.113S.995 7.363.995 6.973c0-.82.156-1.592.47-2.314s.74-1.358 1.288-1.905 1.182-.977 1.904-1.29S6.152.998 6.972.998c.625 0 1.22.088 1.787.264s1.083.42 1.552.733c.47.352.89.752 1.26 1.2s.674.948.908 1.495c.234-.547.537-1.045.908-1.494s.79-.85 1.26-1.2c.47-.314.986-.558 1.553-.733S17.364.997 17.99.997z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIco11);
export default __webpack_public_path__ + "static/media/ico-11.847b69d6264bef7efbf6c4bfb86fe313.svg";
export { ForwardRef as ReactComponent };